import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { ChordEditBlastRadius } from "../../models/ChordHistoryOptions.model";
import { ChordInScaleEdit } from "../../models/wasm.model";
import ChordEditor from "../music_controls/ChordEditor";
import LabelledCheckbox from "../theme_reuse/LabelledCheckbox";
import "./ChordEditPopup.css";
import CloseableModal from "./CloseableModal";

type ChordSaveSettings = {
  blastRadius: ChordEditBlastRadius;
  // maybe where it gets saved to.  Parent could curry that in.
};
interface Props {
  centerX: number;
  centerY: number;
  chord: ChordInScaleEdit;
  onSave: (chord: ChordInScaleEdit, opts: ChordSaveSettings) => void;
  onClose: () => void;
}
interface State {}

export default class ChordEditPopup extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  handleSaveChord = (chord: ChordInScaleEdit) => {
    const blastRadius = this.context.chordHistoryOptions.edits.blastRadius;
    this.props.onSave(chord, { blastRadius });
    this.props.onClose();
  };
  handleChangeChordEditBlastRadius = () => {
    // there's room for different blast radius options, but while it's 2 just using label
    const blastRadius =
      this.context.chordHistoryOptions.edits.blastRadius === ChordEditBlastRadius.AllInstances
        ? ChordEditBlastRadius.OnlyThisInstance
        : ChordEditBlastRadius.AllInstances;
    const oldEdits = this.context.chordHistoryOptions.edits;
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { ...oldEdits, edits: { blastRadius } } });
  };

  render(): ReactNode {
    const { centerX, centerY, chord, onClose } = this.props;
    // const chordName = toShortChordNameOverBass({ ...chord, chord_type: buildChordTypeFromSortedChordIntervals(notes) }, bass_note);

    return (
      <CloseableModal mini centerX={centerX} centerY={centerY} onClose={onClose}>
        <ChordEditor chord={chord} onSave={this.handleSaveChord} />
        <div className="chord-edit-popup-options">
          <LabelledCheckbox
            isChecked={this.context.chordHistoryOptions.edits.blastRadius === ChordEditBlastRadius.AllInstances}
            checkboxUniqueId="blast-radius-cb"
            labelText="Edit all matches"
            onChange={this.handleChangeChordEditBlastRadius}
          />
        </div>
      </CloseableModal>
    );
  }
}

ChordEditPopup.contextType = AppContextType;
